// test526
(526 && 0);
